module.exports = "pegasus/assets/theme3/medium/4.jpg";